import { Section } from '~/components/common/section';
import { XAxis, YAxis, BarChart, Tooltip, ResponsiveContainer, Bar, Cell } from 'recharts';
import { FC } from 'react';
// import { Translate } from '~/i18n';
// import { DateTime } from 'luxon';
import useBestSellingProducts from '~/apis/dashboard-statistics/useBestSellingProducts';
import EmptyState from './empty-states';
import { SubmitLoader } from '~/components/common/loaders/submit';
import { Translate, useTranslate } from '~/i18n';
// import { useAuth } from '~/auth';
import { formatNumber } from '~/utils/format-price';

const CustomizedAxisTick: FC<any> = (props: any) => {
   const { x, y, payload } = props;

   // const { user } = useAuth();

   return (
      <g transform={`translate(${x},${y})`}>
         <text x={0} y={0} dy={0} fontSize={14} textAnchor="end" fill="#B5B5C3">
            {formatNumber(payload.value)} SR
         </text>
      </g>
   );
};

// const CustomizedBar: FC<any> = (props: any) => {
//    const { x, y, payload, width, height, fill } = props;

//    return (
//       <g transform={`translate(${x},${y})`}>
//          <path d={`M 0 0 H ${width} V ${height} H 0 V 0`} fill="#B5B5C3" />;
//       </g>
//    );
// };

const barColors = ['#B5B5C3', '#8950FC', '#FFA800', '#3699FF', '#1BC5BC'];

const ProductsChart = () => {
   const { data: BestSellingProducts, isLoading } = useBestSellingProducts({ limit: 5 });
   const { translate } = useTranslate();
   return (
      <Section className=" py-8 px-5 h-full">
         <div className="px-5 mb-6">
            <span className="block mb-2 text-lg font-semibold">
               <Translate id="dashboard:best selling products" />
            </span>
            {/* <span className="block text-xs font-medium text-gray-400">
               426 <Translate id="dashboard:orders in the past month" />
            </span> */}
         </div>
         <div className="w-full h-[250px] sm:h-[400px]">
            {isLoading ? (
               <div className="w-full h-full flex justify-center items-center">
                  <SubmitLoader />
               </div>
            ) : BestSellingProducts?.data?.length === 0 ? (
               <EmptyState />
            ) : (
               <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                     //   width={500}
                     //   height={400}
                     data={BestSellingProducts?.data?.slice(0, 5)}
                     margin={{
                        top: 10,
                        right: 30,
                        left: 15,
                        bottom: 0,
                     }}>
                     <XAxis dataKey="venue_name" stroke="#B5B5C3" fontSize={14} />
                     <YAxis tick={<CustomizedAxisTick />} />

                     <Tooltip />

                     <Bar
                        //shape={<CustomizedBar />}
                        dataKey="total_amount"
                        name={translate({ id: 'bookings:total amount' })}>
                        {BestSellingProducts?.data?.slice(0, 5).map((_1: any, index: any) => (
                           <Cell key={`cell-${index}`} fill={barColors[index]} />
                        ))}
                     </Bar>
                  </BarChart>
               </ResponsiveContainer>
            )}
         </div>
      </Section>
   );
};

export default ProductsChart;
